import { inject, Injectable } from "@angular/core"
import { EnvironmentService } from "./environment.service";
import { DataService } from "./data.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class ValidateCardNumberService {

    #dataService = inject(DataService)
    #environmentService = inject(EnvironmentService)
    #validateUrl = this.#environmentService.getUrl('securedata/validatecard')

    validateCardNumber(cardNumber: number) {
        const reqHeaders = new HttpHeaders().set('Content-Type', 'application/json')
        const body = {"CreditCardNumber": cardNumber}
        return this.#dataService.post<any, any>(this.#validateUrl, body, reqHeaders);
    }
}